import { SUB_TRACT } from 'assets/images'
import ItemNFTStyled from './styled'
import IconMerahOrKuda from '../IconMerahOrKuda'
import { RateStar } from 'features/Horse/components'
import { useSearchParams } from 'react-router-dom'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import MemoizedImageRaratyCommon from 'shared/MemoizedImage/RaratyCommon'
import MemoizedImageRaratyEpic from 'shared/MemoizedImage/RaratyEpic'
import MemoizedImageRaratyLegendary from 'shared/MemoizedImage/RaratyLegendary'
import MemoizedImageRaratyMythic from 'shared/MemoizedImage/RaratyMythic'
import MemoizedImageRaratyRare from 'shared/MemoizedImage/RaratyRare'
import { ShopTypeRariTy } from 'models'
interface ItemNFTProps {
  avt?: string
  itemName?: string
  price?: number
  id?: string
  onClick?: (id: string) => void
  type?: string
  isDetail?: boolean
  currency?: string
  level?: string
  rarityType?: string
}

export default function ItemNFT({ level, currency, isDetail, type, onClick, avt, itemName = '', price, id = '', rarityType, ...props }: ItemNFTProps) {
  const [searchParams] = useSearchParams()
  const paramsSearch = Object.fromEntries(searchParams.entries())
  const { t } = useTranslation()

  const generateRateLevel = (maxLevel: number, currentLevel: number): JSX.Element[] => {
    const rateStars: JSX.Element[] = []
    for (let i = 0; i < maxLevel; i++) {
      rateStars.push(<RateStar key={i} isActive={i < currentLevel} />)
    }
    return rateStars
  }

  const showIconRariTy = () => {
    const valueRariry = rarityType
    const handleKeySort = () => {
      switch (valueRariry) {
        case ShopTypeRariTy.ALL:
          return ''
        case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
          return <MemoizedImageRaratyCommon />
        }
        case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
          return <MemoizedImageRaratyEpic />
        }
        case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
          return <MemoizedImageRaratyLegendary />
        }
        case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
          return <MemoizedImageRaratyMythic />
        }
        case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
          return <MemoizedImageRaratyRare />
        }
        default:
          return valueRariry
      }
    }
    return handleKeySort()
  }

  const bgIconRariTy = () => {
    const valueRariry = rarityType
    const handleKeySort = () => {
      switch (valueRariry) {
        case ShopTypeRariTy.ALL:
          return ''
        case ShopTypeRariTy.COMMON.toLocaleUpperCase(): {
          return 'bg-common'
        }
        case ShopTypeRariTy.EPIC.toLocaleUpperCase(): {
          return 'bg-epic'
        }
        case ShopTypeRariTy.LEGENDARY.toLocaleUpperCase(): {
          return 'bg-legendary'
        }
        case ShopTypeRariTy.MYTHIC.toLocaleUpperCase(): {
          return 'bg-mythic'
        }
        case ShopTypeRariTy.RARE.toLocaleUpperCase(): {
          return 'bg-rare'
        }
        default:
          return ''
      }
    }
    return handleKeySort()
  }

  return (
    <ItemNFTStyled {...props} >
      <div className={`item ${isDetail && 'detail'} ${type?.toLowerCase()} ${!isDetail && `bg-rarity ${bgIconRariTy()}`}`}>
        <img className='sub-tract' src={SUB_TRACT} alt="" />
        <img className='avt-item' src={avt} alt="" />
         {!isDetail && rarityType &&
          <div className='rarity'>
            {showIconRariTy()}
          </div>
        }
        {!isDetail &&
          <div className='description'>
            {(level && paramsSearch.type === 'DOPING') ? (
              <div className='level d-flex align-items-center justify-content-center'>{generateRateLevel(Number(level), Number(level))}</div>
            ) : ''}
            <h4 className='item-name'>{itemName}</h4>
            <div className='color-white'>
              <IconMerahOrKuda type={currency} price={price || 0} />
            </div>
          </div>
        }
        <div className='btn-detail-container'>
          <button className='font-bold btn-detail' onClick={() => onClick?.(id)} >
            <span className='color-white'>{t(`${NOTIFICATION_MESSAGE}.details`)}</span>
          </button>
        </div>
      </div>
    </ItemNFTStyled>
  )
}
